import * as types from "./unassignedProviderListActionType";

export const fetchUnassignedProviderListRequest = (payload = {}) => ({
  type: types.FETCH_UNASSIGNED_PROVIDER_LIST_REQUEST,
  payload,
});

export const fetchUnassignedProviderListSuccess = (data) => ({
  type: types.FETCH_UNASSIGNED_PROVIDER_LIST_SUCCESS,
  payload: data,
});

export const fetchUnassignedProviderListFailure = (error) => ({
  type: types.FETCH_UNASSIGNED_PROVIDER_LIST_FAILURE,
  payload: error,
});